import { render, staticRenderFns } from "./ArticleBlock.vue?vue&type=template&id=ef23c5ea&scoped=true&"
import script from "./ArticleBlock.vue?vue&type=script&lang=ts&"
export * from "./ArticleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleBlock.vue?vue&type=style&index=0&id=ef23c5ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef23c5ea",
  null
  
)

export default component.exports